var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgAnnouncement = function SvgAnnouncement(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#DC2626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m7.441 10.208 1.423 4.459H5.947l-1.41-4.03m2.904-.429c-.972.11-1.938.282-2.905.43m2.905-.43a18.287 18.287 0 0 1 5.44.197m-8.345.232-1.088.166a3.417 3.417 0 0 1-1.132-4.226L5.429 5.36a18.285 18.285 0 0 0 5.254-3.156m2.198 8.201c.104.06.202.081.29.058.584-.157.55-2.176-.075-4.51-.626-2.334-1.606-4.1-2.19-3.943-.088.023-.162.09-.223.194m2.198 8.201c-.583-.336-1.368-1.906-1.899-3.886-.53-1.98-.635-3.732-.299-4.315"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAnnouncement);
export default ForwardRef;